// import { useContext } from "react";
// import ENV from "./ENV";
// import textHelpers from "app/utils/textHelpers";
// import diff from ""
const Diff = require("diff");

let diffHelpers = {
  getDiffLines(string1 = "", string2 = "") {
    // const diff = Diff.diffChars(string1, string2);
    // const diff = Diff.diffLines(string1, string2, {
    //   newlineIsToken: true,
    //   ignoreWhitespace: true,
    // });
    // console.log("DIFF LINES", diff);

    // const diffWithoutLines = Diff.diffLines(string1, string2, {
    //   newlineIsToken: false,
    //   ignoreWhitespace: false,
    // });
    // console.log("DIFF LINES w/o new line token", diffWithoutLines);
    // let parts = diffWithoutLines;

    const diffArrays = Diff.diffArrays(
      string1.split(/[\r\n]/),
      string2.split(/[\r\n]/)
    );
    console.log("DIFF arrays", diffArrays);
    let parts = [];
    diffArrays.forEach((d) => {
      d.value.forEach((v) => {
        let part = { value: v };
        if (d.removed) part.removed = true;
        if (d.added) part.added = true;
        parts.push(part);
      });
    });

    console.log(parts);

    let diffRes = [];
    let index = 0;
    parts.forEach((part, i) => {
      if (part.removed) {
        if (!!parts[i + 1] && parts[i + 1].added) {
          // line was replaced
          let text = parts[i + 1].value;
          let prevText = part.value;
          let lineDiff = diffRes.push({
            index,
            text,
            prevText,
            lineDiff: diffHelpers.getDiffWords(prevText, text),
            replaced: true,
          });
          index++;
        } else {
          // lines was just removed
          diffRes.push({
            index: null,
            prevIndex: index,
            text: part.value,
            removed: true,
          });
          // don't increment index
        }
      } else if (part.added) {
        if (!!parts[i - 1] && parts[i - 1].removed) {
          // line was replaced (handled by previous line)
        } else {
          // line was added
          diffRes.push({
            index,
            text: part.value,
            added: true,
          });
          index++;
        }
      } else {
        // line was unchanged
        diffRes.push({
          index,
          text: part.value,
        });
        index++;
      }
    });

    // diff.forEach((part) => {
    //   // green for additions, red for deletions
    //   // grey for common parts
    //   const color = part.added ? 'green' :
    //     part.removed ? 'red' : 'grey';
    //   process.stderr.write(part.value[color]);
    // });
    return diffRes;
  },
  getDiffWords(string1 = "", string2 = "") {
    const diff = Diff.diffWordsWithSpace(string1, string2);
    console.log("DIFF WORDS", diff);
    return diff;
  },
};

export default diffHelpers;
